"use client";

import React from "react";
import type { FC, HTMLAttributes } from "react";
import Script from "next/script";

import { useFeatureFlag } from "@/components/utilities/featureFlag";
import { useEnvironmentVariables } from "@/contexts/environmentVariables";
import { useSession } from "@/contexts/session";

// The widget is a custom element registered by the ElevenLabs embed script.
// Typing the tag name as a component avoids augmenting the global JSX namespace,
// which is brittle under React 19 / Next 15.
const ConvaiWidget = "elevenlabs-convai" as unknown as FC<
	HTMLAttributes<HTMLElement> & { "agent-id": string }
>;

// Pinned ElevenLabs embed bundle, served from the unpkg CDN. Bump the version
// deliberately, and allow this host in any CSP / Permissions-Policy added at the
// edge.
const ELEVENLABS_EMBED_SRC =
	"https://unpkg.com/@elevenlabs/convai-widget-embed@0.14.3/dist/index.js";

const ElevenLabsVoiceAgent = () => {
	const isEnabled = useFeatureFlag("CHARTER_HALL_VOICE_AGENT");
	const { hasAuthenticatedSession, hasSessionExpired } = useSession();
	const { elevenLabsAgentId } = useEnvironmentVariables();

	if (
		!isEnabled ||
		!hasAuthenticatedSession ||
		hasSessionExpired ||
		!elevenLabsAgentId
	) {
		return null;
	}

	return (
		<>
			<Script src={ELEVENLABS_EMBED_SRC} strategy="lazyOnload" />
			<ConvaiWidget agent-id={elevenLabsAgentId} />
		</>
	);
};

export default ElevenLabsVoiceAgent;
